import { useQuery } from '@tanstack/react-query';

import { getFeeScheduleById, getFeeSchedules } from 'api';

export const feeScheduleByIdQueryKey: any[] = ['get-fee-schedule-by-id'];
const feesScheduleQueryKey: any[] = ['get-fee-schedule'];

export const useGetFeeSchedulesQuery = (payload = {}, overrides = {}) => {
  return useQuery({
    queryKey: feesScheduleQueryKey.concat(payload),
    queryFn: () => getFeeSchedules(payload),
    ...overrides,
  });
};

export const useGetFeeScheduleByIdQuery = (pk: number, overrides = {}) => {
  return useQuery({
    queryKey: feeScheduleByIdQueryKey.concat(pk),
    queryFn: () => getFeeScheduleById(pk),
    ...overrides,
  });
};
